import { createDefaultTyrann } from '@apis/common';
import { patchBookingInquiryLogs } from '@models/BookingInquiryLog';
import * as t from 'io-ts';

export const bookingInquiryLogsApis = createDefaultTyrann({
  '/booking-inquiry-log/{group_id}/': {
    patch: {
      path: t.type({
        group_id: t.string,
      }),
      body: patchBookingInquiryLogs,
      response: {
        200: t.type({}),
      },
    },
  },
});
